import Login from './Login';
import Register from './Register';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import VerifyEmail from './VerifyEmail';

export {
  Login,
  Register,
  ForgotPassword,
  ResetPassword,
  VerifyEmail
};